import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { authActions, permissionsActions, systemActions } from 'store';
import { globalSessionENums, token } from 'utils';
import { getSocket, disconnectSocket } from 'utils/socketManager';
import { SAVE_PROJECT_SESSION } from '../../../store/auth/auth.types';

const PROFILE_REFETCH_DEBOUNCE_MS = 500;

export const GlobalSocket = ({}) => {
    const dispatch = useDispatch();
    const socketRef = useRef(null);
    const profileRefetchTimer = useRef(null);

    useEffect(() => {
        if (!token()) return;
        socketRef.current = getSocket(token());

        if (!socketRef.current) return;

        socketRef.current.on('connect', (res) => {});

        socketRef.current.on('SEND_EVENTS_GLOBAL', (data) => {
            if (data?.evenType === globalSessionENums.PROFILE_UPDATED) {
                clearTimeout(profileRefetchTimer.current);
                profileRefetchTimer.current = setTimeout(() => {
                    dispatch(permissionsActions.getMyPermissions());
                    dispatch(authActions.getMyProfile('noLoad'));
                    dispatch(systemActions.getCompany('noLoad'));
                }, PROFILE_REFETCH_DEBOUNCE_MS);
                return;
            }

            dispatch({
                type: SAVE_PROJECT_SESSION,
                payload: data,
            });
        });

        return () => {
            clearTimeout(profileRefetchTimer.current);
            disconnectSocket();
            socketRef.current = null;
        };
    }, []);

    return <div />;
};
